<!-- 
<div>This is news 
  //appExternalLink
  <a href="https://www.nsc.org" >Go to External Site</a>
</div> 
-->

<ngb-carousel [interval]="10000"  class="memic-carousel" *ngIf="news">

  <ng-template ngbSlide *ngFor="let n of news; index as i;">
    <!-- Common Inner for both link types-->
    <ng-template #innerCarousel>
      <div>
          <img [src]="n.blobUrl" alt="News" (click)="trackImageClick(n)">
      </div>
      <div class="carousel-caption">
        <h3>{{n.heading}}</h3>
        <p>{{n.subheading}}</p>
      </div>
    </ng-template>
    <!-- This is for downloading internal safety director content -->
    <a href="javascript:void(null)" (click)="downloadFile(n.url)" *ngIf="n.url.includes('azure-file:')">
      <ng-container *ngTemplateOutlet="innerCarousel"></ng-container>
    </a>
    <!-- This is for external links -->
    <a [attr.href]="n.url"  
       [attr.target]="n?.openNewTab ? '_blank' : '_self'" 
       rel="nofollow noopener noreferrer" 
       *ngIf="!n.url.includes('azure-file:')" appExternalLink>
      <ng-container *ngTemplateOutlet="innerCarousel"></ng-container>
    </a>
  </ng-template>
</ngb-carousel>
